if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.variantInput = this.form.querySelector('[name=id]');
      if (this.variantInput) this.variantInput.disabled = false;

      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      this.paymentButtonWrap = document.querySelector('.product-form__buttons');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.cartPromise = null;

      if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // this.variantInput?.addEventListener('change', () => {
      //   this.updateNotifyButtonState();
      //   // this.updatePaymentButtonState();
      // });
        this.variantInput?.addEventListener('change', async () => {
          this.updateNotifyButtonState();

          // Reset disabled state when switching variants
          this.error = false;
          this.submitButton?.removeAttribute('aria-disabled');

          // Force fresh cart read for new variant
          await this.fetchCart(true);
        });

      this.updateNotifyButtonState();
      // this.updatePaymentButtonState();
      this.fetchCart();
      const qtyInput = this.form.querySelector('[name="quantity"]');
      if (qtyInput) {
        qtyInput.addEventListener('input', () => {
          if (qtyInput.value === '0' || qtyInput.value === '' || parseInt(qtyInput.value, 10) < 1) {
            qtyInput.value = 1;
          }
        });
      }
    }
    async fetchCart(force = false) {
      // 1. If not forcing, and cache is fresh, return cached data instantly.
      if (!force && this.cachedCart) return this.cachedCart;
      
      // 2. If not forcing and a request is already running, wait for that request (the promise).
      if (!force && this.cartPromise) return this.cartPromise;

      // 3. Start a new fetch and save the promise to prevent concurrent requests.
      this.cartPromise = fetch('/cart.js')
        .then(res => res.json())
        .then(data => {
          this.cachedCart = data;
          this.cartPromise = null; // Clear the promise on success
          return data;
        })
        .catch(e => {
          this.cartPromise = null; // Clear the promise on error
          console.error('Cart fetch failed:', e);
          throw e;
        });

      return this.cartPromise;
    }
    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner')?.classList.remove('hidden');

      const formData = new FormData(this.form);
      const variantId = formData.get('id');
      const variantIdNum = Number(variantId);
      let requestedQty = parseInt(formData.get('quantity'), 10);
      // Always ensure at least 1 is shown in the input box visually
        if (isNaN(requestedQty) || requestedQty < 1) {
        requestedQty = 1;
        const qtyInput = this.form.querySelector('[name="quantity"]');
        if (qtyInput) qtyInput.value = 1;
        }

        // Determine the max quantity for this product-form (lower of tagMax and globalMax)
        const tagMax = this.dataset.max ? parseInt(this.dataset.max, 10) : 0;
        const globalMax = window.maxProductQuantity || 0;

        if (!isNaN(tagMax) && tagMax > 0 && globalMax > 0) {
        this.maxQty = Math.min(tagMax, globalMax);
        } else if (!isNaN(tagMax) && tagMax > 0) {
        this.maxQty = tagMax;
        } else {
        this.maxQty = globalMax;
        }

        const maxQty = this.maxQty || Number(window.maxProductQuantity);

      try {
      const cart = await this.fetchCart();
      const existing = cart.items.find(i => Number(i.variant_id) === variantIdNum);
      const currentQty = existing ? existing.quantity : 0;

      // Determine max allowed quantity for this variant
      const tagMax = this.dataset.max ? parseInt(this.dataset.max, 10) : 0;
      const globalMax = window.maxProductQuantity || 0;
      let maxQty = tagMax && globalMax ? Math.min(tagMax, globalMax) : tagMax || globalMax;

      // Calculate remaining allowed quantity
      const remainingQty = maxQty - currentQty;
      const isArabic = document.documentElement.lang === "ar";
      const alertText = isArabic 
        ? "لقد وصلت إلى الحد الأقصى للكمية المسموح بها لهذا المنتج" 
        : "This item has reached the maximum quantity allowed in your cart";

      // Check if requested quantity exceeds remaining
      if (requestedQty > remainingQty) {
          requestedQty = remainingQty;
          const qtyInput = this.form.querySelector('[name="quantity"]');
          if (qtyInput) qtyInput.value = remainingQty;
          alert(alertText);
          this.resetButton();
          return;
      }


        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map(s => s.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const res = await fetch(`${routes.cart_add_url}`, config);
        const response = await res.json();

        if (window.location.pathname.includes('/cart')) {
          window.location.reload();
          return;
        }

        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message
          });
          this.handleErrorMessage(response.description);
          const soldMsg = this.submitButton?.querySelector('.sold-out-message');
          if (soldMsg) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText?.classList.add('hidden');
            soldMsg.classList.remove('hidden');
          }
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error) {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response
          });
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        }

        // Invalidate cached cart so future checks read latest cart.
        // this.cachedCart = null;
        this.fetchCart(true).catch(e => console.error('Background cart refresh failed:', e));

        const quickAddModal = this.closest('quick-add-modal');
        const renderAndUpdate = () => {
          CartPerformance.measure("add:paint-updated-sections", () => this.cart.renderContents(response));
          // this.updatePaymentButtonState();
        };

        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => setTimeout(renderAndUpdate), { once: true });
          quickAddModal.hide(true);
        } else {
          renderAndUpdate();
        }
      } catch (err) {
        console.error('Cart error:', err);
      } finally {
        this.resetButton();
        CartPerformance.measureFromEvent("add:user-action", evt);
      }
    }

    resetButton() {
      this.submitButton?.classList.remove('loading');
      this.querySelector('.loading__spinner')?.classList.add('hidden');
      if (!this.error) this.submitButton?.removeAttribute('aria-disabled');
      if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    }

    handleErrorMessage(msg = false) {
      if (this.hideErrors) return;
      const wrappers = document.querySelectorAll('.product-form__error-message-wrapper');
      if (!wrappers?.length) return;
      const messages = document.querySelectorAll('.product-form__error-message');
      wrappers.forEach(w => w.toggleAttribute('hidden', !msg));
      if (msg) messages.forEach(m => (m.textContent = msg));
    }
   toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton?.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton?.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    updateNotifyButtonState() {
      const addBtn = document.querySelector('.addtocart-dyanamic-buttons');
      if (!addBtn || !this.variantInput) return;
      const idNum = Number(this.variantInput.value);
      const variant = window.productVariants?.find(v => Number(v.id) === idNum);
      if (!variant) return;
      addBtn.classList.toggle('notify-button-none', !variant.available);
    }
  });
}
